import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V = {
  '@id': string;
  '@type': 'MetricActivity';
  id: string;
  date: string;
  thought: string | null;
  steps: number | null;
  exercise: number | null;
  sleep: number | null;
  timeInDaylight: number | null;
  heartRateVariability: number | null;
  mood: Array<{
    '@id': string;
    '@type': 'Mood';
    id: string;
    title: string;
  }>;
};

export type V_UserTopMood = {
  '@id': string;
  '@type': 'MetricActivity';
  mood: {
    '@id': string;
    '@type': 'Mood';
    id: string;
    title: string;
  };
  count: number;
};

export type W = {
  date: string;
  thought: string | null;
  steps: number | null;
  exercise: number | null;
  sleep: number | null;
  timeInDaylight: number | null;
  heartRateVariability: number | null;
  mood: Array<string>;
};

export function useReadCollectionMetricActivities(
  id: string,
  queryParams?: {
    'date[after]'?: string;
    'date[before]'?: string;
    'date[strictly_after]'?: string;
    'date[strictly_before]'?: string;
  },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V>>(
    `/users/${id}/metric-activities${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadCollectionTopMoodsStartDateEndDate(
  id: string,
  startDate: string,
  endDate: string,
  queryParams?: {
    'date[after]'?: string;
    'date[before]'?: string;
    'date[strictly_after]'?: string;
    'date[strictly_before]'?: string;
    limit?: string;
  },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_UserTopMood>>(
    `/users/${id}/top-moods/${startDate}/${endDate}${makeQueryString(
      queryParams,
    )}`,
    options,
  );
}
